import { render } from "./choose-face-dialog.vue?vue&type=template&id=4bf0d5f0&scoped=true&ts=true"
import script from "./choose-face-dialog.vue?vue&type=script&lang=ts"
export * from "./choose-face-dialog.vue?vue&type=script&lang=ts"

import "./choose-face-dialog.vue?vue&type=style&index=0&id=4bf0d5f0&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf0d5f0"]])

export default __exports__